import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Config from '../../../../Config';
import { reportDWH } from '../AddonsAndUpgradesBlockSlice';
import PurpleInfo from '../../../Shared/PurpleInfo/PurpleInfo';
import { setCurrentProcess, setSelectedTvSubscriber, setRegistrationParams } from '../../StreamingRegistrationRedirectionBlock/StreamingRegistrationSlice';
import { StreamingRegistrationProcessTypes, DISNEY_REGISTRATION_PARAMS, HBO_REGISTRATION_PARAMS } from '../../StreamingRegistrationRedirectionBlock/utils/constants';
import Image from 'app/Components/Shared/Image/image';

const UserAddonList = (props) => {

    useEffect(() => {
        props.reportDWH({ actionType: `My Zone ${props.worldType} Lobby`, status: 'Ongoing', messageText: 'My Services Tab Displayed' });
    }, []);

    function handleHboRegistrationClick() {
        props.setRegistrationParams(HBO_REGISTRATION_PARAMS);
        props.setCurrentProcess(StreamingRegistrationProcessTypes.PACKAGE_EXIST);
        props.setSelectedTvSubscriber(props.selectedSubscriber?.subscriberNumber);
        props.context.navigateTo(Config.redirectToHboUrl);
    }

    function handleDisneyRegistrationClick() {
        props.setRegistrationParams(DISNEY_REGISTRATION_PARAMS);
        props.setCurrentProcess(StreamingRegistrationProcessTypes.PACKAGE_EXIST);
        props.setSelectedTvSubscriber(props.selectedSubscriber?.subscriberNumber);
        props.context.navigateTo(Config.redirectToDisneyUrl);
    }

    return (
        <>
            {
                props.serviceList?.length > 0 ? (
                    <div className='addon-list-wrapper'>
                        {
                            props.serviceList.map((item, index) => {
                                if (item.selfCareCmsData?.isRestricted && !props.isFullAuthenticated) {
                                    return;
                                }
                                let icon = item.selfCareCmsData?.icon;
                                if (!icon) { icon = item.selfCareCmsDataCriteria?.icon; }
                                if (!item.isMandatory) { icon = item.selfCareCmsDataCriteria?.icon; }

                                const isHboItem = item.selfCareCmsData?.id?.toLowerCase().includes('hbo');
                                const isDisneyItem = item.selfCareCmsData?.id?.toLowerCase().includes('dis');

                                return (
                                    <div className='addon-item' key={index}>
                                        {icon && <div className='image-wrapper'> <Image src={Config.epiBaseUrl + icon} alt='' /> </div>}
                                        <div className={`details-wrapper${isHboItem && props.hboStatus === 'B' ? ' hbo-active' : ''}${isDisneyItem && (props.disneyStatus === 'B' || props.disneyStatus === 'D') ? ' disney-active' : ''}`}>
                                            <div className='details-text-wrapper'>
                                                <div className={`addon-title${isHboItem && props.hboStatus === 'B' ? ' hbo-active' : ''}${isDisneyItem && (props.disneyStatus === 'B' || props.disneyStatus === 'D') ? ' disney-active' : ''}`}> {item.selfCareCmsData?.title ? item.selfCareCmsData?.title : item.description}
                                                    {isHboItem && props.hboStatus === 'B' && (
                                                        <PurpleInfo text={
                                                            <>כדי לצפות בתכנים יש ליצור חשבון{' '}
                                                                <a onClick={(e) => { e.preventDefault(); handleHboRegistrationClick(); }} style={{ textDecoration: 'underline', cursor: 'pointer' }}>ב-HBO Max</a>
                                                            </>
                                                        } />
                                                    )}
                                                    {isDisneyItem && props.disneyStatus === 'B' && (
                                                        <PurpleInfo text={
                                                            <>כדי לצפות בתכנים יש ליצור חשבון{' '}
                                                                <a onClick={(e) => { e.preventDefault(); handleDisneyRegistrationClick(); }} style={{ textDecoration: 'underline', cursor: 'pointer' }}>בדיסני+</a>
                                                            </>
                                                        } />
                                                    )}
                                                    {isDisneyItem && props.disneyStatus === 'D' && (
                                                        <PurpleInfo text={
                                                            <>יש להתחבר עם החשבון שנרשמת איתו{' '}
                                                                <a onClick={(e) => { e.preventDefault(); handleDisneyRegistrationClick(); }} style={{ textDecoration: 'underline', cursor: 'pointer' }}>לדיסני+</a>
                                                            </>
                                                        } />
                                                    )}</div>
                                                {
                                                    item.isMandatory ? (
                                                        <div className='addon-sub-title'> כלול בחבילה </div>
                                                    ) : (
                                                        <div className='addon-sub-title'> {item.selfCareCmsData?.subTitle ? item.selfCareCmsData?.subTitle : item.selfCareCmsDataCriteria?.subTitle} </div>
                                                    )
                                                }
                                                {item.ipAddress && <div className='addon-sub-title'>כתובת ה-IP הקבועה שלך היא: {item.ipAddress}</div>}
                                            </div>
                                        </div>
                                        {
                                            !item.isMandatory &&
                                            <div className='button-wrapper'> <a href='#' onClick={(e) => { e.preventDefault(); props.onServiceClick(e, item); }}>פרטים</a> </div>
                                        }
                                    </div>
                                );
                            })
                        }
                    </div>
                ) : (
                    <div className='no-results-wrapper'>
                        <div className='icon-wrapper'></div>
                        <div className='no-results'>
                            <div className='no-results-title'> עדיין לא הוספת שדרוגים לחשבון שלך </div>
                            <div className='no-results-sub-title'> אפשר להוסיף אותם בקלות ובמהירות לחשבון </div>
                        </div>
                    </div>
                )
            }
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        worldType: state.addonsAndUpgradesBlock.worldType,
        hboStatus: state.addonsAndUpgradesBlock.hboStatus,
        disneyStatus: state.addonsAndUpgradesBlock.disneyStatus,
        selectedSubscriber: state.selfcarePage.selectedSubscriber,
    };
};

const mapDispatchToProps = {
    reportDWH,
    setCurrentProcess,
    setSelectedTvSubscriber,
    setRegistrationParams,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserAddonList);
